
import React, { useState } from 'react';
import { Button } from '../base/Button';

export const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <h1 className="text-2xl font-bold text-blue-600" style={{ fontFamily: '"Pacifico", serif' }}>
              Business Academy
            </h1>
          </div>
          
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('academy')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              Academy
            </button>
            <button 
              onClick={() => scrollToSection('leistungen')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              Leistungen
            </button>
            <button 
              onClick={() => scrollToSection('vorteile')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              Vorteile
            </button>
            <button 
              onClick={() => scrollToSection('anmeldung')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              Anmeldung
            </button>
            <Button 
              onClick={() => scrollToSection('warteliste')}
              variant="primary"
              size="sm"
            >
              Warteliste
            </Button>
          </nav>

          <button
            className="md:hidden flex items-center justify-center w-8 h-8 cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4 pt-4">
              <button 
                onClick={() => scrollToSection('academy')}
                className="text-gray-700 hover:text-blue-600 transition-colors text-left cursor-pointer"
              >
                Academy
              </button>
              <button 
                onClick={() => scrollToSection('leistungen')}
                className="text-gray-700 hover:text-blue-600 transition-colors text-left cursor-pointer"
              >
                Leistungen
              </button>
              <button 
                onClick={() => scrollToSection('vorteile')}
                className="text-gray-700 hover:text-blue-600 transition-colors text-left cursor-pointer"
              >
                Vorteile
              </button>
              <button 
                onClick={() => scrollToSection('anmeldung')}
                className="text-gray-700 hover:text-blue-600 transition-colors text-left cursor-pointer"
              >
                Anmeldung
              </button>
              <Button 
                onClick={() => scrollToSection('warteliste')}
                variant="primary"
                size="sm"
                className="self-start"
              >
                Warteliste
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
